import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginService } from '@frontend/util-client-auth';
import { ScoButtonModule, ScoLinksModule, ScoInputModule } from '@schueco/schueco-ui-components';
import { CLIENT_DATA } from '@frontend/util-api-data';
import { clearDownloadList } from '@frontend/data-access-download-list';
import { Store } from '@ngrx/store';
import { clearLandRole } from '@frontend/data-access-land-role';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorPopupComponent } from '@frontend/ui-error-dialog';
import { Dialog } from '@angular/cdk/dialog';

@Component({
  selector: 'dc-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ScoButtonModule, ScoLinksModule, ScoInputModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  private loginService = inject(LoginService);
  private store = inject(Store);
  private translate = inject(TranslateService);
  private http = inject(HttpClient);
  private dialog = inject(Dialog);

  clientData = inject(CLIENT_DATA);
  links = {
    PASSWORD_FORGOTTEN: '',
    REGISTER: '',
  };

  username = '';
  validUsername = true;
  password = '';
  validPassword = true;
  regName = '';
  isLoggingIn = false;

  ngOnInit(): void {
    const language = this.translate.currentLang || 'de';
    this.loadUrls(language);
  }

  async login() {
    if (this.isLoggingIn) {
      return;
    }
    if (this.username === '') {
      this.validUsername = false;
    } else {
      this.validUsername = true;
    }
    if (this.password === '') {
      this.validPassword = false;
    } else {
      this.validPassword = true;
    }
    if (this.username === '' || this.password === '') {
      return;
    }

    this.isLoggingIn = true;
    this.store.dispatch(clearDownloadList());
    this.store.dispatch(clearLandRole());
    try {
      const success = await Promise.resolve(this.loginService.login(this.username, this.password));
      if (!success) {
        this.dialog.open(ErrorPopupComponent, {
          width: '80%',
          maxWidth: '450px',
          data: {
            message: this.translate.instant('LOGIN_FAILED'),
          },
        });
      }
    } finally {
      this.isLoggingIn = false;
    }
  }

  openLink(url: string) {
    if (url) {
      window.location.href = url;
    }
  }

  loadUrls(lang: string) {
    const urlFilePath = `assets/urls/${lang}.json`;
    this.http.get<any>(urlFilePath).subscribe({
      next: (res) => {
        if (res[this.clientData.name]) {
          this.links = res[this.clientData.name];
        } else {
          console.warn(`Client "${this.clientData.name}" nicht in der URL-Datei gefunden`);
        }
      },
      error: () => console.error(`URL-Datei für Sprache ${lang} konnte nicht geladen werden.`),
    });
  }
}
